import cn from 'classnames';

import cls from './Tag.module.scss'

interface Props {
    type: 'new'|'hit'|'pre_order'
}

export const Tag = ({type}: Props) => {

    let text = ''
    switch (type) {
        case 'new': text = 'НОВИНКА'; break;
        case 'hit': text = 'ХИТ'; break;
        case 'pre_order': text = 'ПРЕДЗАКАЗ'; break;
    }

    return (
        <div className={cn([
            cls.tag,
            type === 'new' && cls.new,
            type === 'hit' && cls.hit,
            type === 'pre_order' && cls.pre_order,
        ])}>{text}</div>
    )
}